export const ResultPanelSidebarData = [
  {
    title: "ADD RESULT",
    link: "resultCompilation",
  },
  {
    title: "STUDENT RESULT",
    link: "studentResult",
  },
  {
    title: "IMPORT RESULT",
    link: "importResult",
  },
  {
    title: "USER DATA SEARCH",
    link: "userDataSearch",
  },
  {
    title: "IMPORT STUDENT",
    link: "importStudent",
  },
  {
    title: "NATIONAL DUTY USERS",
    link: "nationalDutyUsers",
  },
  {
    title: "Qualification /Ranks Prediction",
    link: "qualificationAndranksPrediction",
  },
  {
    title: "RANK MASTER",
    link: "addRankMaster",
  },
  {
    title: "UPCOMING INTERVIEW",
    link: "upcomingInterview",
  },
  {
    title: "IMPORT RESULT COMPILATION",
    link: "importResultCompilation",
  },
  {
    title: "MOVEMENTS OF MEETING",
    subNav: [
      {
        title: "MOVEMENTS OF MEETING",
        path: "movementsOfMeeting",
        cName: "sub-nav",
      },
      {
        title: "EDIT/DELETE",
        path: "editMovementsOfMeeting",
        cName: "sub-nav",
      },
    ],
  },
];

export const ResultPanelEmpSidebarData = [
  {
    title: "EMPLOYEE DETAILS",
    subNav: [
      {
        title: "Dashboard",
        path: "dashboard",
        cName: "sub-nav",
      },
      {
        title: "My Profile",
        path: "userProfile",
        cName: "sub-nav",
      },
      {
        title: "Policies",
        path: "policy",
        cName: "sub-nav",
      },
      {
        title: "KRA/KPI",
        path: "kraKpi",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "ADD RESULT",
    link: "resultCompilation",
  },
  {
    title: "STUDENT RESULT",
    link: "studentResult",
  },
  {
    title: "IMPORT RESULT",
    link: "importResult",
  },
  {
    title: "USER DATA SEARCH",
    link: "userDataSearch",
  },
  {
    title: "IMPORT STUDENT",
    link: "importStudent",
  },
  {
    title: "UPCOMING INTERVIEW",
    link: "upcomingInterview",
  },
  {
    title: "IMPORT RESULT COMPILATION",
    link: "importResultCompilation",
  },
  {
    title: "MOVEMENTS OF MEETING",
    subNav: [
      {
        title: "MOVEMENTS OF MEETING",
        path: "movementsOfMeeting",
        cName: "sub-nav",
      },
      {
        title: "EDIT/DELETE",
        path: "editMovementsOfMeeting",
        cName: "sub-nav",
      },
    ],
  },
];
